import * as actionType from '../action-type';

export const updateQuickReport = (data) => ({
  type: actionType.UPDATE_QUICK_REPORT,
  payload: data,
});

export const resetQuickReport = () => ({
  type: actionType.RESET_QUICK_REPORT,
});